import { render, staticRenderFns } from "./Optional.vue?vue&type=template&id=0cfcdafe&"
import script from "./Optional.vue?vue&type=script&lang=js&"
export * from "./Optional.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports